/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Workout_After_End_ExercisesInputs */

const en_us2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 exercise`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 exercise`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} exercises`)
	
};

const pt_br2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 exercício`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} exercícios`)
	
};

const es_419_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 ejercicio`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 ejercicio`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} ejercicios`)
	
};

const pt_pt2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 exercício`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} exercícios`)
	
};

const fr_fr2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} exercice sur 1`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} exercice sur 1`);
	return /** @type {LocalizedString} */ (`${i?.done} exercices sur ${i?.total}`)
	
};

const de_de2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Übung`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Übung`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.total} Übungen`)
	
};

const it_it2_workout_after_end_exercises = /** @type {(inputs: Workout_After_End_ExercisesInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 esercizio`);
	if ((i?.total === -1 || i?.total === "-1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 esercizio`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.total} esercizi`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "{done} of 1 exercise" |
* | "-1" | "{done} of 1 exercise" |
* | * | "{done} of {total} exercises" |
*
* @param {Workout_After_End_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_exercises = /** @type {((inputs: Workout_After_End_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_exercises(inputs)
	if (locale === "es-419") return es_419_workout_after_end_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_exercises(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_exercises(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_exercises(inputs)
	return en_us2_workout_after_end_exercises(inputs)
});
export { workout_after_end_exercises as "workout-after.end_exercises" }